<template>
  <v-dialog max-width="600" persistent v-model="dialog">
    <v-card v-if="showConfirmationDialog">
      <v-card-title class="headline">Confirmation</v-card-title>
      <v-card-text>
        <v-card>
          <v-card-text>
            <p>{{ $t('msg.score_generated_text_1') }}</p>
            <p>{{ $t('msg.score_generated_text_2') }}</p>
            <v-card-actions>
              <v-btn class="primary" @click="destroy">{{ $t('cancel') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn class="primary" @click="hideConfirmationDialog">{{ $t('confirm') }}</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
    <v-card v-else>
      <v-card-title class="headline">{{ $t('msg.edit_customer_info') }}</v-card-title>
      <div class="notes"><b style="color: red">*</b> {{ $t('msg.asterisk_remark') }}</div>
      <v-card-text>
        <ValidationObserver ref="observer" v-slot="{failedRules, failed, passes}">
          <v-form>
            <!-- ================= BASIC INFORMATION ================= -->
            <v-row>
              <v-col cols="12">
                <div class="section-header">{{ $t('msg.basic_information') }}</div>
              </v-col>

              <v-col cols="12" md="12">
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: true, min: 1, max: 10, regex: /^[0-9]+$/}"
                                      class="requiredSticker"
                                      name="applicationNumber" ref="observerEditApplicationNumber"
                                      v-slot="{errors, failedRules}">
                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'applicationNumber')"
                                  :label="$t('lbl.application_id')"
                                  @input="customer.applicationNumber = customer.applicationNumber.toUpperCase()"
                                  v-model="customer.applicationNumber"></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
              </v-col>

              <v-col cols="12" md="12">
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: false}"
                                      class="requiredSticker"
                                      name="username" ref="observerEditUsername"
                                      v-slot="{errors, failedRules}">
                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'username')"
                                  :label="$t('lbl.username')"
                                  @input="customer.username = customer.username.toUpperCase()"
                                  v-model="customer.username"
                                  readonly disabled
                    ></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
              </v-col>
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true, min: 3, max: 80, regex: /^[a-zA-Z\s-/@']+$/}"-->
<!--                                      v-slot="{errors, failedRules}">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'firstname')"-->
<!--                                  :label="$t('lbl.firstname')" v-model="customer.firstname"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true, min: 3, max: 80, regex: /^[a-zA-Z\s-/@']+$/}"-->
<!--                                      v-slot="{errors, failedRules}">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'lastname')"-->
<!--                                  :label="$t('lbl.lastname')" v-model="customer.lastname"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true, min: 1, max: 20, regex: /^[a-zA-Z0-9/-]+$/}"-->
<!--                                      name="idNumber"-->
<!--                                      class="requiredSticker"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'idNumber')"-->
<!--                                  @keyup="uppercase"-->
<!--                                  readonly disabled-->
<!--                                  :label="$t('lbl.id_number')"-->
<!--                                  v-model="customer.idNumber">-->
<!--                    </v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
              <v-col cols="12" md="12">
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider :rules="{required: true}" name="gender"
                                      v-slot="{ errors, failedRules }">
                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'gender')"
                                    :items="dropdown.genders"
                                    item-text="text"
                                    item-value="value"
                                    class="requiredSticker"
                                    :label="$t('lbl.gender')"
                                    v-model="customer.gender"></v-autocomplete>
                  </ValidationProvider>
                </v-skeleton-loader>
              </v-col>
<!--              <v-col cols="12" md="12">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true}" name="location"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'location')"-->
<!--                                    :items="locations"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    class="requiredSticker"-->
<!--                                    :label="$t('lbl.location')"-->
<!--                                    v-model="customer.location"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true}" name="product"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'product')"-->
<!--                                    :items="$parent.filters.scheme"-->
<!--                                    @change="handleProductChange"-->
<!--                                    item-text="label"-->
<!--                                    item-value="code"-->
<!--                                    class="requiredSticker"-->
<!--                                    :label="$t('lbl.product_applied')"-->
<!--                                    v-model="customer.productApplied"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
            </v-row>

            <!-- ================= CURRENT EDUCATION ================= -->
<!--            <v-row>-->
<!--              <v-col cols="12">-->
<!--                <div class="section-header">{{ $t('msg.current_education') }}</div>-->
<!--              </v-col>-->

<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="educationLevel"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'educationLevel')"-->
<!--                                    :items="educationLevels"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.education_level')"-->
<!--                                    v-model="customer.educationLevel"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false, max: 80, regex: /^[a-zA-Z0-9\s]+$/}" name="currentFieldOfStudy"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'currentFieldOfStudy')"-->
<!--                                  :label="$t('lbl.field_of_study')"-->
<!--                                  v-model="customer.currentFieldOfStudy"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false, max: 80, regex: /^[a-zA-Z0-9\s]+$/}" name="currentInstitutionName"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'currentInstitutionName')"-->
<!--                                  :label="$t('lbl.education_institution_name')"-->
<!--                                  v-model="customer.currentInstitutionName"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="currentCompletionStatus"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'currentCompletionStatus')"-->
<!--                                    :items="completionStatusItems"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.completion_status')"-->
<!--                                    v-model="customer.currentCompletionStatus"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--            </v-row>-->

            <!-- ================= PAST EDUCATION ================= -->
<!--            <v-row>-->
<!--              <v-col cols="12">-->
<!--                <div class="section-header">{{ $t('msg.past_education') }}</div>-->
<!--              </v-col>-->

<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="pastEducationLevel"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'pastEducationLevel')"-->
<!--                                    :items="educationLevels"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.education_level')"-->
<!--                                    v-model="customer.pastEducationLevel"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false, max: 80, regex: /^[a-zA-Z0-9\s]+$/}" name="pastFieldOfStudy"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'pastFieldOfStudy')"-->
<!--                                  :label="$t('lbl.field_of_study')"-->
<!--                                  v-model="customer.pastFieldOfStudy"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false, max: 80, regex: /^[a-zA-Z0-9\s]+$/}" name="pastInstitutionName"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'pastInstitutionName')"-->
<!--                                  :label="$t('lbl.education_institution_name')"-->
<!--                                  v-model="customer.pastInstitutionName"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="pastStudyResults"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'pastStudyResults')"-->
<!--                                    :items="studyResultRanges"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.past_study_results_gpa_cgpa')"-->
<!--                                    v-model="customer.pastStudyResults"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="pastCompletionStatus"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'pastCompletionStatus')"-->
<!--                                    :items="completionStatusItems"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.completion_status')"-->
<!--                                    v-model="customer.pastCompletionStatus"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--            </v-row>-->

            <!-- ================= FINANCING ================= -->
            <v-row>
              <v-col cols="12">
                <div class="section-header">{{ $t('msg.financing_details') }}</div>
              </v-col>

<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="guardiansIncome"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'guardiansIncome')"-->
<!--                                    :items="incomeRanges"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :prefix="currency"-->
<!--                                    :label="$t('lbl.guardians_income')"-->
<!--                                    v-model="customer.guardiansIncome"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="guardiansEducation"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'guardiansEducation')"-->
<!--                                    :items="educationLevels"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.guardians_education')"-->
<!--                                    v-model="customer.guardiansEducation"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false, max: 120}" name="guardiansEmployment"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'guardiansEmployment')"-->
<!--                                  :label="$t('lbl.guardians_employment')"-->
<!--                                  v-model="customer.guardiansEmployment"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
              <v-col cols="12" md="12">
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider
                      :rules="{required: true, numeric: true, min_value: 500, max_value: 999999999}"
                      name="loanAmount"
                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'financingAmount', [currency, 500, 999999999])"
                        class="requiredSticker"
                        :label="$t('lbl.financing_amount_applied')"
                        :prefix="currency"
                        v-model="customer.loanAmount"></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="12">
                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">
                  <ValidationProvider
                      :rules="{required: true, numeric: true, min_value: 1, max_value: 240}"
                      name="tenureApplied"
                      v-slot="{errors, failedRules}">
                    <v-text-field
                        :error-messages="$translatedErrorMessages(failedRules,'tenureApplied', [1, 240])"
                        class="requiredSticker"
                        :label="$t('lbl.financing_tenure_applied')"
                        required
                        suffix="Months"
                        v-model="customer.tenureApplied"></v-text-field>
                  </ValidationProvider>
                </v-skeleton-loader>
              </v-col>
<!--              <v-col cols="12" md="6">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: false}" name="financingType"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-autocomplete :error-messages="$translatedErrorMessages(failedRules,'financingType')"-->
<!--                                    :items="financingTypeItems"-->
<!--                                    item-text="text"-->
<!--                                    item-value="value"-->
<!--                                    :label="$t('lbl.type_of_financing')"-->
<!--                                    v-model="customer.financingType"></v-autocomplete>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
<!--              <v-col cols="12" md="12" v-if="customer.financingType === 'OTHER'">-->
<!--                <v-skeleton-loader :loading="loading" transition="scale-transition" type="list-item-two-line">-->
<!--                  <ValidationProvider :rules="{required: true, max: 100}" name="financingTypeOther"-->
<!--                                      v-slot="{ errors, failedRules }">-->
<!--                    <v-text-field :error-messages="$translatedErrorMessages(failedRules,'financingTypeOther')"-->
<!--                                  :label="$t('lbl.please_specify')"-->
<!--                                  v-model="customer.financingTypeOther"></v-text-field>-->
<!--                  </ValidationProvider>-->
<!--                </v-skeleton-loader>-->
<!--              </v-col>-->
            </v-row>

            <!-- ================= ERROR MESSAGES ================= -->
            <v-row>
              <v-col cols="12" md="12">
                <div>
                  <div v-show="failed">
                    <p style="color:red">{{ $t('msg.failed_action') }}</p>
                  </div>
                  <div v-show="saveError">
                    <p style="color:red">{{ $t('msg.failed_action') }}</p>
                  </div>
                  <div v-show="serverError">
                    <p style="color:red">{{ $t('error.server') }}</p>
                  </div>
                  <div v-show="informationTampering">
                    <p style="color:red">{{ $t('error.information_tampering') }}</p>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card-actions align="right">
                  <v-spacer></v-spacer>
                  <v-skeleton-loader class="mr-3" :loading="loading||sending" transition="scale-transition"
                                     type="button">
                    <v-btn @click="destroy" color="primary">{{ $t('cancel') }}</v-btn>
                  </v-skeleton-loader>
                  <v-skeleton-loader :loading="loading||sending" transition="scale-transition" type="button">
                    <v-btn @click="passes(saveCustomer)" color="primary" dark>{{ $t('save') }}</v-btn>
                  </v-skeleton-loader>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import {dataServices} from "@/services";

export default {
  name: 'CustomerMaintenance',
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      loading: false,
      dialog: false,
      menu: false,
      dropdown: {},
      branches: [],
      date: new Date().toISOString().substr(0, 10),
      editedCommencementDate: '',
      editBusinessCategoryDropdownData: [],
      validation: false,
      customer: {},
      selectedProduct: {
        validation: {
          minAmount: 500,
          maxAmount: 999999999,
          minTenure: 1,
          maxTenure: 240
        }
      },
      malaysianOwnedItems: [
        {text: 'Yes', value: 'Yes'},
        {text: 'No', value: 'No'}
      ],

      locations: [
        {text: 'Rural', value: 'RURAL'},
        {text: 'Suburban', value: 'SUBURBAN'},
        {text: 'Urban', value: 'URBAN'}
      ],
      completionStatusItems: [
        {text: 'Complete', value: 'COMPLETE'},
        {text: 'Not Complete', value: 'NOT_COMPLETE'}
      ],
      educationLevels: [
        {text: 'No Formal Education', value: 'NO_FORMAL'},
        {text: 'Primary School', value: 'PRIMARY'},
        {text: 'Secondary School (PMR/PT3)', value: 'SECONDARY_PMR'},
        {text: 'Secondary School (SPM)', value: 'SECONDARY_SPM'},
        {text: 'STPM / A-Level', value: 'STPM'},
        {text: 'Certificate', value: 'CERTIFICATE'},
        {text: 'Diploma', value: 'DIPLOMA'},
        {text: 'Bachelor Degree', value: 'BACHELOR'},
        {text: 'Master Degree', value: 'MASTER'},
        {text: 'Doctorate (PhD)', value: 'PHD'}
      ],

      studyResultRanges: [
        {text: 'Below 2.00', value: 'BELOW_2'},
        {text: '2.00 - 2.49', value: 'RANGE_2_2_49'},
        {text: '2.50 - 2.99', value: 'RANGE_2_5_2_99'},
        {text: '3.00 - 3.49', value: 'RANGE_3_3_49'},
        {text: '3.50 - 3.99', value: 'RANGE_3_5_3_99'},
        {text: '4.00', value: 'EQUAL_4'}
      ],

      financingTypeItems: [
        {text: '100%', value: 'PERCENT_100'},
        {text: '75%', value: 'PERCENT_75'},
        {text: '50%', value: 'PERCENT_50'},
      ],

      incomeRanges: [
        {text: '2000 and below', value: 'BELOW_2000'},
        {text: '2001 - 3000', value: 'RANGE_2001_3000'},
        {text: '3001 - 4000', value: 'RANGE_3001_4000'},
        {text: '4001 - 5000', value: 'RANGE_4001_5000'},
        {text: '5001 - 6000', value: 'RANGE_5001_6000'},
        {text: '6001 - 7000', value: 'RANGE_6001_7000'},
        {text: '7001 - 8000', value: 'RANGE_7001_8000'},
        {text: '8001 - 9000', value: 'RANGE_8001_9000'},
        {text: '9001 - 10000', value: 'RANGE_9001_10000'},
        {text: '10001 and above', value: 'ABOVE_10000'}
      ],

      errors: [],
      showConfirmationDialog: false,
      failed: false,
      serverError: false,
      saveError: false,
      informationTampering: false,
      sending: false,
      currency: 'RM',
      financingType: '',
    }
  },
  methods: {
    init(customer, validation, financingType) {
      this.loading = true
      this.financingType = financingType
      this.customer = Object.assign({}, customer)
      this.validation = validation
      if (this.customer.gfiScoreGenerationCount === null || (this.customer.gfiScoreGenerationCount > 0 && !this.customer.hasGfiScore)) {
        this.showConfirmationDialog = false
      } else if (this.customer.gfiScoreGenerationCount === 1) {
        this.showConfirmationDialog = true
      }
      this.initDropdown()
      this.dialog = true
      let productValidation = this.$parent.filters.scheme.filter(f => f.code === this.customer.productApplied)[0].validation
      if (productValidation)
        this.selectedProduct.validation = productValidation
    },
    initDropdown: function () {
      dataServices.getUserDropDowns(this.$parent.userType.toUpperCase()).then(response => {
        this.dropdown = response.dataResponse
        this.branches = response.dataResponse.branch
        this.identificationNumberTypes = response.dataResponse.identificationNumberTypes
        if (!this.dropdown.locations) {
          this.dropdown.locations = this.locations
        }
        this.loading = false
      })
    },
    saveCustomer() {
      this.sending = true
      this.serverError = false
      this.informationTampering = false
      dataServices.saveCustomer(this.customer).then(r => {
        console.log(this.customer)
        this.sending = false
        if (r.successful) {
          this.$parent.renderMessage('Successfully updated customer information.')
          this.dialog = false
        } else {
          console.log('error')
          r.errorList.forEach(e => {
            if (e.field === 'applicationNumber' && e.rule === 'duplicate') {
              this.$refs.observerEditApplicationNumber.applyResult({
                errors: ['error'],
                failedRules: ['duplicate']
              });
            }
            if (e.field === 'assessment' && e.rule === 'duplicate') {
              this.informationTampering = true
            }
            if (e.field === 'businessRegistrationNumber' && e.rule === 'duplicate') {
              this.informationTampering = true
            }
            if (e.field === 'idNumber' && e.rule === 'duplicate') {
              this.informationTampering = true
            }
          })
        }
      }).catch(error => {
        console.log(error)
        this.sending = false
        this.serverError = true
        console.log('Error' + error)
      })
    },
    hideConfirmationDialog() {
      this.showConfirmationDialog = false
    },
    destroy() {
      this.dialog = false
      this.serverError = false
      this.saveError = false
      this.informationTampering = false
    },
    handleProductChange() {
      this.selectedProduct.validation = this.$parent.filters.scheme.filter(f => f.code === this.customer.productApplied)[0].validation
    },
    uppercase() {
      this.customer.idNumber = this.customer.idNumber.toUpperCase();
      this.customer.businessRegistrationNumber = this.customer.businessRegistrationNumber.toUpperCase();
    }
  },
  computed: {
    isLoanOfficer: function () {
      return this.$store.state.home.user.roles.includes('ROLE_LOAN_OFFICER')
    }
  },
  watch: {
    'customer.commencementDate': function () {
      if (this.customer.commencementDate) {
        const [year, month, day] = this.customer.commencementDate.substr(0, 10).split('-')
        this.editedCommencementDate = `${day}-${month}-${year}`
      } else
        this.editedCommencementDate = ''
    },
    editedCommencementDate: function (newCommencementDate) {
      if (!newCommencementDate) {
        this.customer.commencementDate = null
      }
    }
  },
}
</script>

<style>
.requiredSticker label::after {
  content: "*";
  color: red;
}

.notes {
  padding-left: 27px;
  margin-top: -15px;
  font-size: 12px;
  color: grey;
}

.section-header {
  font-size: 16px;
  font-weight: 600;
  color: #1976d2;
  border-bottom: 2px solid #1976d2;
  padding-bottom: 4px;
  margin: 16px 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.uppercase input {
  text-transform: uppercase;
}

.msg-error {
  font-size: 12px;
  font-family: 'Ubuntu', sans-serif;
  color: #a70f1c;
  line-height: 1;
  margin-top: -27px !important;
  padding-left: 13px;
}

.tenure {
  margin-bottom: -30px !important;
  margin-top: -10px !important;
  font-size: 12px;
}
</style>